import React from "react";
import {Text} from '@fluentui/react';

const ListHeader = () => {
  return (
      <div style={{marginLeft:50}}>
          <Text variant={'xLarge'} block>
            Task List
          </Text>
      </div>
  );
};

export default ListHeader;

